<!-- Modal -->
<div class="modal fade" id="membershipDetails" tabindex="-1" aria-labelledby="membershipModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="membershipModalLabel">{{"MEMBERSHIP.LOGS" | translate}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeMembershipModal()"></button>
            </div>
            <div class="modal-body">

                <table class="table table-bordered table-striped" *ngIf="logs.length > 0">
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th class="text-center">{{"MEMBERSHIP.ACTION" | translate}}</th>
                            <th class="text-center">{{"MEMBERSHIP.OLD_STATUS" | translate}}</th>
                            <th class="text-center">{{"MEMBERSHIP.NEW_STATUS" | translate}}</th>
                            <th class="text-center">{{"MEMBERSHIP.NOTES" | translate}}</th>
                            <th class="text-center">{{"MEMBERSHIP.DATE" | translate}}</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let log of logs; let i = index">
                            <td class="text-center">{{ i + 1 }}</td>
                            <td class="text-center">{{ log.membershipAction }}</td>
                            <td class="text-center">{{ log.oldStatus }}</td>
                            <td class="text-center">{{ log.newStatus }}</td>
                            <td class="text-center">{{ log.note || '-' }}</td>
                            <td class="text-center">{{ log.createdOn | date:'dd-MM-yyyy HH:mm'
                                }}</td>
                        </tr>
                    </tbody>
                </table>

                <div *ngIf="logs.length === 0" class="text-muted">
                    No logs found.
                </div>
                <div class="modal-footer">
                    <button type="button" class="rts-btn btn-primary text-light" data-bs-dismiss="modal"
                        (click)="closeMembershipModal()">
                        {{"MEMBERSHIP.CLOSE" |translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>